export default {
  table: '表格',
  card: '卡片',

  alarmType: '告警类型',
  alarmTime: '告警时间',
  alarmImage: '告警图片',
  alarmVideo: '告警视频',

  alarmTypeLabel: '告警类型：',
  alarmTimeLabel: '告警时间：',
  alarmImageLabel: '告警图片：',

  noAlarmData: '暂无告警数据',

  alarmVideoTitle: '告警视频',
  screenshotFileName: '截图',
}
